// Copyright (c) 2026 Chain Capital Technologies Ltd. All rights reserved.
// See LICENSE file in the project root for full license information.

import { ErrorScreen } from './error-screen.js';

interface BootstrapUnreachableProps {
  onRetry: () => void;
}

/**
 * F17.1 — full-screen replacement shown when the SPA can't reach the
 * backend at startup (i.e. `GET /version` failed). Replaces the entire
 * SessionProvider subtree, so no half-rendered home page peeks
 * through. Retry re-issues the version fetch via the parent's
 * bootstrap effect.
 */
export function BootstrapUnreachable({ onRetry }: BootstrapUnreachableProps) {
  return (
    <ErrorScreen
      title="Can't reach Cobault"
      body={
        <>
          <p>
            We can't reach the Cobault backend right now. This usually
            means a temporary network blip on your connection or on our
            side.
          </p>
          <p>Check your connection and try again in a moment.</p>
        </>
      }
      primaryLabel="Try again"
      onPrimary={onRetry}
    />
  );
}
